import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
const initialState = {
    uploading: false,
    error: null,
};
// Fetch the client's connections (network + account name) for the popup dropdowns.
export const fetchImportConnectionsThunk = createAsyncThunk("affiliateClickImport/fetchConnections", async (clientId, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token;
        const response = await ApiCall("GET", `/api/affiliate-click-import/connections?client_id=${clientId}`, "", { Authorization: token ? `Bearer ${token}` : "" });
        if (response && response.data?.success) {
            return (response.data.data || []);
        }
        return rejectWithValue(response?.data?.message || "Failed to fetch connections");
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to fetch connections");
    }
});
// Upload a CSV/XLSX click report for a client + network + account.
// Nothing is persisted server-side — the file is validated and handed off.
export const bulkImportAffiliateClicksThunk = createAsyncThunk("affiliateClickImport/bulkImport", async (payload, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        const response = await ApiCall("POST", "/api/affiliate-click-import/bulk-upload", payload, { Authorization: token ? `Bearer ${token}` : "" });
        if (response && response.data?.success) {
            return response.data;
        }
        // ApiCall returns the axios error object on failure, so the real
        // message may live under either `data` or `response.data`.
        return rejectWithValue(response?.data?.message ||
            response?.response?.data?.message ||
            "Failed to import clicks");
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message || error?.message || "Click import failed");
    }
});
const affiliateClickImportSlice = createSlice({
    name: "affiliateClickImport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(bulkImportAffiliateClicksThunk.pending, (state) => {
            state.uploading = true;
            state.error = null;
        })
            .addCase(bulkImportAffiliateClicksThunk.fulfilled, (state) => {
            state.uploading = false;
        })
            .addCase(bulkImportAffiliateClicksThunk.rejected, (state, action) => {
            state.uploading = false;
            state.error = action.payload || "Click import failed";
        });
    },
});
export const selectAffiliateClickImportUploading = (state) => state.affiliateClickImport.uploading;
export default affiliateClickImportSlice.reducer;
